/**
 * @author Ariel
 * @desc 帖子表单页面
 * @date 2020-09-10
 */
import React from "react";
import { connect } from 'dva'
import { framework_tool, component_tool } from '../../../../../tool'
import { WizTableForm } from "../../../../common";

let { WizContainer, modelUtils, WizOssUpload } = framework_tool
let { WizCard, WizSpin, WizForm, WizButton } = component_tool

const topicConfig = WizTableForm.Config.topic(this, { apiParams: { state: 1 } })

class InvitationDetail extends WizContainer {
  componentName = 'invitationDetail';

  constructor(props) {
    super(props)
    this.state = {}
  }

  _componentDidMount() {
  }

  propsAndStateOnChange = {
    addInvitation: this._addInvitationOver.bind(this)
  }

  _addInvitationOver(nextProps, nextState) {
    if (nextProps.addInvitation.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/interact/community/invitation');
    } else {
      wizNotice.error('提交失败：' + nextProps.addInvitation.msg);
    }
    return true;
  }

  _addInvitation(values) {
    let { changeImg } = this.state
    let imgList = []
    changeImg && changeImg.length && changeImg.forEach(img => {
      imgList.push(img.fileId)
    })
    if (imgList && imgList.length && imgList.length > 9) {
      wizNotice.error('最多上传9张图片')
      return false;
    } else {
      values['imgList'] = imgList
      if (Array.isArray(values['topicId'])) {
        values['topicId'] = null
      }
      let apiPath = 'invitation/add';
      this.doAction({
        path: apiPath,
        payload: {
          key: 'addInvitation',
          apiParams: { ...values }
        }
      })
    }
  }

  _render() {
    const { invitationLoading } = this.props
    let columns = [
      {
        name: 'id',
        formItem: {
          type: 'hidden'
        }
      },
      {
        name: 'sourceType',
        formItem: {
          type: 'hidden',
          initialValue: 0
        }
      },
      {
        title: '模块信息',
        name: 'modeType',
        formItem: {
          rules: [
            { required: true }
          ],
          type: 'select',
          initialValue: 0,
          disabled: true
        },
        dict: [
          { code: 0, codeName: '同事圈' },
          { code: 1, codeName: '精彩瞬间' }
        ]
      },
      {
        title: '隐私设置',
        name: 'secrecyType',
        formItem: {
          rules: [
            { required: true }
          ],
          type: 'select',
          initialValue: 0,
        },
        dict: [
          { code: 0, codeName: '公开' },
          { code: 1, codeName: '粉丝可见' },
          { code: 2, codeName: '自己可见' },
        ]
      },
      {
        title: '话题',
        name: 'topicId',
        formItem: {
          ...topicConfig,
          diy: WizTableForm,
          selectType: 'radio',
        }
      },
      {
        title: '帖子内容',
        name: 'content',
        formItem: {
          maxLength: 1500,
          placeholder: '帖子内容最多输入1500个字',
          type: 'textarea'
        }
      },
      {
        title: '图片',
        name: 'imgs',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form;
            let { changeImg } = this.state
            let children = changeImg && changeImg.length >= 9 ? null : <WizButton>选择文件</WizButton>
            return (
              <div>
                {
                  getFieldDecorator('imgList', {
                    initialValue: []
                  })(
                    <WizOssUpload
                      accept={'.jpg, .jpeg, .png'}
                      listType={'picture-card'}
                      uploadType={'invitation'}
                      onChange={(files) => {
                        this.setState({
                          changeImg: files,
                          time: new Date()
                        })
                      }}
                      children={children}
                    />
                  )}
              </div>
            )
          }
        }
      }
    ]
    let onSubmit = this._addInvitation.bind(this);
    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      }
    }

    return (
      <WizCard>
        <WizSpin tip={'加载中'} spinning={invitationLoading}>
          <WizForm className={'form-inline'} {...formProps} />
        </WizSpin>
      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { invitation } = state;
  const addInvitation = modelUtils.getModelEntity(invitation, 'addInvitation')
  const load = modelUtils.getLoadingState(state, 'invitation')
  return {
    addInvitation,
    ...load
  }
}

export default connect(mapStateToProps)(InvitationDetail);
